import React from 'react';
import type { LucideIcon } from 'lucide-react';
import { ArrowRight, FileQuestion } from 'lucide-react';
import { Card, GradientText } from '../../components/ui/index.tsx';
import { formatCurrency } from '../../utils/index.ts';

export interface WelcomeInsightProps {
    title: string;
    text: string;
    icon: LucideIcon;
    onLearnMore?: () => void;
}

export interface AcatLevelInfo {
    label: string;
    budget: number;
    description?: string;
}

export interface AcatInsightCardProps {
    personName: string;
    levelData: AcatLevelInfo;
}

export const WelcomeInsight = ({ title, text, icon: Icon, onLearnMore }: WelcomeInsightProps) => (
    <Card className="bg-white/80 sticky top-8">
        <h3 className="text-xl font-bold mb-4 flex items-center gap-2">
            <Icon className="text-blue-500" /> <GradientText>{title}</GradientText>
        </h3>
        <p className="text-gray-600">{text}</p>
        {onLearnMore && (
            <div className="mt-4 flex justify-center">
                <button
                    onClick={onLearnMore}
                    className="px-4 py-2 bg-white text-blue-600 border-2 border-blue-600 rounded-lg hover:bg-blue-50 transition-colors text-sm font-medium flex items-center gap-2"
                >
                    Learn more about your state's process <ArrowRight size={16} />
                </button>
            </div>
        )}
    </Card>
);

export const AcatInsightCard = ({ personName, levelData }: AcatInsightCardProps) => (
    <Card className="bg-white/80">
        <h3 className="text-lg font-bold mb-2 flex items-center gap-2">
            <FileQuestion className="text-blue-500" /> <GradientText>{personName}'s Approval</GradientText>
        </h3>
        <div className="text-gray-800">
            <p className="font-semibold">{levelData.label}</p>
            <p className="text-sm text-gray-600 mt-1">This provides a total annual budget of approximately <span className="font-bold text-gray-700">{formatCurrency(levelData.budget)}</span>. This is a combination of the government subsidy and any contributions you may be asked to make.</p>
        </div>
    </Card>
);
